export type QualityProfile = {
  tier: "performance" | "balanced" | "quality";
  pixelRatio: number;
  antialias: boolean;
  shadows: boolean;
  particles: number;
};

export function detectQuality(): QualityProfile {
  const nav = navigator as Navigator & { deviceMemory?: number };
  const cores = navigator.hardwareConcurrency || 4;
  const memory = nav.deviceMemory || 4;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const coarsePointer = window.matchMedia?.("(pointer: coarse)").matches ?? false;
  const mobileViewport = Math.min(window.innerWidth, window.innerHeight) <= 900;
  const mobileUa = /Android|iPhone|iPad|Mobile/i.test(navigator.userAgent);

  // The Hunt scene has animated wildlife and many vegetation draw calls. On a
  // phone, stable frame pacing is more valuable than desktop-level pixel ratio
  // and real-time shadows. Preserve PBR materials/lighting while cutting the
  // expensive GPU work that is hardest on mobile browsers.
  if (coarsePointer || mobileViewport || mobileUa) {
    if (cores <= 4 || memory <= 3) {
      return {
        tier: "performance",
        pixelRatio: Math.min(dpr, 1.05),
        antialias: false,
        shadows: false,
        particles: 12,
      };
    }

    return {
      tier: "performance",
      pixelRatio: Math.min(dpr, 1.2),
      antialias: false,
      shadows: false,
      particles: 16,
    };
  }

  if (cores <= 4 || memory <= 3) {
    return {
      tier: "performance",
      pixelRatio: Math.min(dpr, 1.2),
      antialias: false,
      shadows: false,
      particles: 18,
    };
  }

  if (cores <= 6 || memory <= 6) {
    return {
      tier: "balanced",
      pixelRatio: Math.min(dpr, 1.55),
      antialias: true,
      shadows: true,
      particles: 36,
    };
  }

  return {
    tier: "quality",
    pixelRatio: dpr,
    antialias: true,
    shadows: true,
    particles: 64,
  };
}
